(function () {
  var PIN_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" focusable="false">' +
    '<path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>' +
    '</svg>';

  function numOrNull(value) {
    if (value == null || value === '') return null;
    var n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function buildMapQuery(address, lat, lng) {
    if (address) return encodeURIComponent(address);
    if (lat != null && lng != null) return lat + ',' + lng;
    return '';
  }

  function buildDirectionsUrl(title, address, lat, lng) {
    if (address) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address);
    }
    if (lat != null && lng != null) {
      return (
        'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng)
      );
    }
    if (title) {
      return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(title);
    }
    return '';
  }

  function buildEmbedSrc(title, address, lat, lng, zoom) {
    // Match live v3.5: address-first query + www.google.com embed (maps.google.com often blanks).
    var query = buildMapQuery(address, lat, lng);
    if (!query && title) query = encodeURIComponent(title);
    if (!query) return '';
    return 'https://www.google.com/maps?q=' + query + '&z=' + zoom + '&output=embed';
  }

  function ensureMapIframe(frame, titleAttr) {
    if (!frame) return null;
    var iframe = frame.querySelector('[data-pic-map-iframe]');
    if (iframe) return iframe;
    iframe = document.createElement('iframe');
    iframe.setAttribute('data-pic-map-iframe', '');
    iframe.setAttribute('title', titleAttr || 'Workshop location map');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    iframe.style.cssText = 'border:0;width:100%;height:100%;display:block;';
    frame.insertBefore(iframe, frame.firstChild);
    return iframe;
  }

  function applyMapDetail(mapEl, detail, useDefault) {
    if (!mapEl) return;
    var mode = mapEl.getAttribute('data-pic-map-dynamic');
    if (!mode) return;

    var payload = useDefault ? readDefaultDetail(mapEl) : detail || {};
    var address = String(payload.address || '').trim();
    var title = titleWithRegion(
      String(payload.title || '').trim(),
      address,
      payload.region_code || payload.state_code || ''
    );
    var lat = numOrNull(payload.lat);
    var lng = numOrNull(payload.lng);
    var zoom = mapEl.getAttribute('data-pic-map-zoom') || '15';
    var showLabel = mapEl.getAttribute('data-pic-show-label') === '1';
    var frame = mapEl.querySelector('[data-pic-map-frame]') || mapEl;
    var iframe = ensureMapIframe(frame, mapEl.getAttribute('data-pic-iframe-title') || 'Workshop location map');

    // v3.5: label-only = overlay only. On coral we still move the map when we have address
    // (preferred) or coords — never title-only overwrite that yields a blank tile.
    var canMoveMap = !!address || (lat != null && lng != null);
    if (iframe && mode !== 'label-only' && canMoveMap) {
      var src = buildEmbedSrc(title, address, lat, lng, zoom);
      if (src && iframe.getAttribute('src') !== src) iframe.src = src;
    } else if (iframe && mode === 'label-only' && canMoveMap) {
      var src2 = buildEmbedSrc(title, address, lat, lng, zoom);
      if (src2 && iframe.getAttribute('src') !== src2) iframe.src = src2;
    }

    if (showLabel) {
      var loc = ensureLocationOverlay(frame, true);
      var directionsUrl = buildDirectionsUrl(title, address, lat, lng);
      updateLocationOverlay(loc, title, address, directionsUrl);
    }
  }

  /** City label + region code (e.g. "Aurora, CO") when address/payload has a state. */
  function titleWithRegion(title, address, regionCode) {
    var t = String(title || '').trim();
    if (!t) return t;
    var code = String(regionCode || '')
      .trim()
      .toUpperCase();
    if (!code || code.length !== 2) {
      var m = String(address || '').match(/,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
      code = m ? m[1].toUpperCase() : '';
    }
    if (!code || code.length !== 2) return t;
    if (new RegExp(',\\s*' + code + '\\s*$', 'i').test(t)) return t;
    return t + ', ' + code;
  }

  function ensureLocationOverlay(frame, showLabel) {
    if (!frame || !showLabel) return null;
    var loc = frame.querySelector('[data-pic-map-location]');
    if (loc) return loc;

    loc = document.createElement('a');
    loc.className = 'pic-map__location';
    loc.setAttribute('data-pic-map-location', '');
    loc.target = '_blank';
    loc.rel = 'noopener noreferrer';
    loc.innerHTML =
      '<span class="pic-map__location-pin" aria-hidden="true">' +
      PIN_SVG +
      '</span>' +
      '<span class="pic-map__location-text">' +
      '<span class="pic-map__location-title" data-pic-map-location-title></span>' +
      '<span class="pic-map__location-address" data-pic-map-location-address hidden></span>' +
      '</span>';
    frame.appendChild(loc);
    return loc;
  }

  function updateLocationOverlay(loc, title, address, directionsUrl) {
    if (!loc) return;
    var titleEl = loc.querySelector('[data-pic-map-location-title]');
    var addressEl = loc.querySelector('[data-pic-map-location-address]');
    if (titleEl) titleEl.textContent = title || '';
    if (addressEl) {
      if (address) {
        addressEl.textContent = address;
        addressEl.hidden = false;
      } else {
        addressEl.textContent = '';
        addressEl.hidden = true;
      }
    }
    if (directionsUrl && loc.tagName === 'A') {
      loc.href = directionsUrl;
    }
    loc.hidden = !title && !address;
  }

  function readDefaultDetail(mapEl) {
    return {
      title: mapEl.getAttribute('data-pic-default-title') || '',
      address: mapEl.getAttribute('data-pic-default-address') || '',
      lat: numOrNull(mapEl.getAttribute('data-pic-default-lat')),
      lng: numOrNull(mapEl.getAttribute('data-pic-default-lng')),
    };
  }

  function collectEnabledFacilities(detail) {
    var out = [];
    if (!detail) return out;
    var seen = Object.create(null);
    function push(label) {
      var t = '';
      if (label == null) return;
      if (typeof label === 'string' || typeof label === 'number') t = String(label).trim();
      else if (typeof label === 'object') {
        t = String(label.label || label.name || label.title || label.value || '').trim();
      } else {
        t = String(label).trim();
      }
      if (!t) return;
      var key = t.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(t);
    }
    if (Array.isArray(detail.facilities)) {
      detail.facilities.forEach(push);
    }
    if (Array.isArray(detail.facility_options)) {
      detail.facility_options.forEach(push);
    }
    if (detail.wheelchair_accessible) push('Wheelchair accessible');
    if (detail.accessible_toilets) push('Accessible toilets');
    if (detail.ground_level) push('Ground level');
    if (detail.accessible_parking) push('Accessible parking spot available');
    if (detail.lift_to_all_floors) push('Lift to all floors');
    return out;
  }

  var ICON_YES =
    '<span class="pic-facility__icon pic-facility__icon--yes" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<circle class="pic-ico-bg" cx="12" cy="12" r="11"/>' +
    '<path class="pic-ico-mark" d="M7.2 12.4l3 3.1 6.6-7"/>' +
    '</svg></span>';

  var ICON_NO =
    '<span class="pic-facility__icon pic-facility__icon--no" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<circle class="pic-ico-bg" cx="12" cy="12" r="11"/>' +
    '<path class="pic-ico-mark" d="M8 8l8 8M16 8l-8 8"/>' +
    '</svg></span>';

  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function readFacilityOptionList(root) {
    var host = root.querySelector('[data-pic-facilities]') || root;
    var raw = host.getAttribute('data-pic-facility-options') || '';
    if (!raw) {
      return [...root.querySelectorAll('[data-pic-facility-label]')]
        .map(function (el) {
          return el.getAttribute('data-pic-facility-label') || '';
        })
        .filter(Boolean);
    }
    return raw
      .split('|')
      .map(function (s) {
        return String(s || '').trim();
      })
      .filter(Boolean);
  }

  /** Base section options + any custom venue options not already listed. */
  function mergeFacilityOptions(baseOptions, enabledLabels) {
    var out = [];
    var seen = Object.create(null);
    function push(label) {
      var t = String(label || '').trim();
      if (!t) return;
      var key = t.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(t);
    }
    (Array.isArray(baseOptions) ? baseOptions : []).forEach(push);
    (Array.isArray(enabledLabels) ? enabledLabels : []).forEach(push);
    return out;
  }

  function applyFacilitiesLayout(host, count) {
    if (!host) return;
    var n = Number(count) || 0;
    var cols = 2;
    var colsMobile = 2;
    var size = 15;
    var icon = 22;
    var gapY = 12;
    var gapX = 28;

    if (n >= 16) {
      cols = 4;
      colsMobile = 2;
      size = 12;
      icon = 17;
      gapY = 8;
      gapX = 12;
    } else if (n >= 12) {
      cols = 4;
      colsMobile = 2;
      size = 12.5;
      icon = 18;
      gapY = 9;
      gapX = 14;
    } else if (n >= 9) {
      cols = 3;
      colsMobile = 2;
      size = 13;
      icon = 18;
      gapY = 10;
      gapX = 16;
    } else if (n >= 7) {
      cols = 3;
      colsMobile = 2;
      size = 13.5;
      icon = 20;
      gapY = 10;
      gapX = 18;
    } else if (n >= 5) {
      cols = 3;
      colsMobile = 2;
      size = 14;
      icon = 20;
      gapY = 11;
      gapX = 20;
    }

    host.style.setProperty('--pic-fac-cols', String(cols));
    host.style.setProperty('--pic-fac-cols-mobile', String(colsMobile));
    host.style.setProperty('--pic-fac-size', size + 'px');
    host.style.setProperty('--pic-fac-icon', icon + 'px');
    host.style.setProperty('--pic-fac-gap-y', gapY + 'px');
    host.style.setProperty('--pic-fac-gap-x', gapX + 'px');
    host.setAttribute('data-pic-fac-count', String(n));
  }

  function renderFacilities(root, enabledLabels) {
    if (!root) return;
    var host = root.querySelector('[data-pic-facilities]') || root;
    var grid = root.querySelector('[data-pic-facilities-grid]');
    var empty = root.querySelector('[data-pic-facilities-empty]');
    if (!grid) return;
    var base = readFacilityOptionList(root);
    var options = mergeFacilityOptions(base, enabledLabels);
    var enabled = Object.create(null);
    (Array.isArray(enabledLabels) ? enabledLabels : []).forEach(function (label) {
      var t = String(label || '').trim().toLowerCase();
      if (t) enabled[t] = true;
    });
    if (!options.length) {
      grid.innerHTML = '';
      applyFacilitiesLayout(host, 0);
      if (empty) empty.hidden = Object.keys(enabled).length > 0;
      return;
    }
    applyFacilitiesLayout(host, options.length);
    grid.innerHTML = options
      .map(function (label) {
        var on = !!enabled[String(label).trim().toLowerCase()];
        return (
          '<div class="pic-facility' +
          (on ? '' : ' pic-facility--off') +
          '" data-pic-facility data-pic-facility-label="' +
          escapeAttr(label) +
          '" data-pic-facility-on="' +
          (on ? '1' : '0') +
          '">' +
          (on ? ICON_YES : ICON_NO) +
          '<span class="pic-facility__label">' +
          escapeHtml(label) +
          '</span></div>'
        );
      })
      .join('');
    if (empty) empty.hidden = true;
  }

  function onVenueSelected(e) {
    var detail = e && e.detail;
    if (!detail) return;
    document.querySelectorAll('[data-pic-map-dynamic]').forEach(function (mapEl) {
      applyMapDetail(mapEl, detail, false);
    });
    var facilities = collectEnabledFacilities(detail);
    document.querySelectorAll('[data-pic-section]').forEach(function (root) {
      renderFacilities(root, facilities);
    });
  }

  function onVenueReset() {
    document.querySelectorAll('[data-pic-map-dynamic]').forEach(function (mapEl) {
      applyMapDetail(mapEl, null, true);
    });
    document.querySelectorAll('[data-pic-section]').forEach(function (root) {
      renderFacilities(root, []);
    });
  }

  document.addEventListener('wbw:venue-selected', onVenueSelected);
  document.addEventListener('wbw:venue-reset', onVenueReset);

  function scrollToBookingWizard() {
    var wizard = document.querySelector('.wbw-root');
    if (!wizard || !wizard.scrollIntoView) return;
    wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initSection(root) {
    if (!root || root.dataset.picInit === '1') return;
    root.dataset.picInit = '1';

    root.querySelectorAll('[data-pic-scroll-wizard]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToBookingWizard();
      });
    });

    var facHost = root.querySelector('[data-pic-facilities]');
    if (facHost) {
      var initialCount =
        facHost.querySelectorAll('[data-pic-facility]').length ||
        readFacilityOptionList(root).length;
      applyFacilitiesLayout(facHost, initialCount);
    }

    var tabs = root.querySelectorAll('[data-pic-tab]');
    var panels = root.querySelectorAll('[data-pic-panel]');
    var select = root.querySelector('[data-pic-tabs-select]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-pic-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-pic-panel') === id;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
      if (select && select.value !== id) select.value = id;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-pic-tab'));
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        activate(select.value);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pic-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
})();
